import { useCallback, useEffect, useState } from 'react';
import { readStored, writeStored } from '@/lib/storage';

export type Theme = 'dark' | 'light';
export const THEME_KEY = 'prepai.theme';

function initialTheme(): Theme {
  return readStored(THEME_KEY) === 'light' ? 'light' : 'dark';
}

/** Dark is the default; light sets data-theme="light" on <html>. Persisted per browser. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'light') root.dataset.theme = 'light';
  else delete root.dataset.theme;
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(initialTheme);
  useEffect(() => applyTheme(theme), [theme]);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next: Theme = t === 'dark' ? 'light' : 'dark';
      writeStored(THEME_KEY, next);
      return next;
    });
  }, []);
  return [theme, toggle];
}
